import { createSlice } from '@reduxjs/toolkit';
import { setAlert } from 'redux/alert';
import { AppDispatch, RootState } from 'redux/store';

import api from 'api';
import { getErrorMessage } from 'utils/v2/errorHelper';
import { TicketInterface } from 'types';

interface TicketStoreInterface {
    tickets: TicketInterface[];
    loading: boolean;
}

const initialState: TicketStoreInterface = {
    tickets: [],
    loading: false,
};

export const ticketSlice = createSlice({
    name: 'app/tickets',
    initialState,
    reducers: {
        setTickets: (state, action) => {
            state.tickets = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        clearTicketStore: (state) => {
            state.tickets = [];
            state.loading = false;
        },
    },
});

export const { clearTicketStore, setLoading, setTickets } = ticketSlice.actions;
export default ticketSlice.reducer;

export const fetchTickets = (applicationId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            if (getState().tickets.loading) {
                return;
            }

            dispatch(setLoading(true));
            const response = await api.tickets.getTicketsByApplication(applicationId);
            setTickets(response.data);
        } catch (error) {
            dispatch(setAlert({ message: getErrorMessage(error), type: 'error' }));
        } finally {
            dispatch(setLoading(false));
        }
    };
};
